import React from 'react';
import { contactInfo } from '../data/mock';
import { Mail, Phone, Scale } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0f172a] border-t border-[#1e293b] py-16">
      <div className="max-w-[87.5rem] mx-auto px-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:max-w-sm">
            <div 
              className="cursor-pointer mb-6" 
              onClick={() => scrollToSection('hero')}
            >
              <span className="text-white font-bold text-2xl tracking-tight uppercase">
                The <span className="text-[#3b82f6]">Real Estate</span> Paralegal
              </span>
            </div>
            <p className="text-[#94a3b8] font-medium leading-relaxed mb-4">
              Professional paralegal services exclusively for attorneys with 15+ years of expertise in commercial and residential real estate transactions.
            </p>
            {/* Attorney Badge */}
            <div className="inline-flex items-center gap-2 bg-[#1e293b] border border-[#3b82f6]/30 rounded-full px-3 py-1.5">
              <Scale size={14} className="text-[#3b82f6]" />
              <span className="text-[#3b82f6] text-xs font-semibold uppercase tracking-wide">
                For Attorneys Only
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-wide text-sm mb-6">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              <button 
                onClick={() => scrollToSection('services')}
                className="text-[#94a3b8] hover:text-white transition-colors duration-300 text-left font-medium"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-[#94a3b8] hover:text-white transition-colors duration-300 text-left font-medium"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-[#94a3b8] hover:text-white transition-colors duration-300 text-left font-medium"
              >
                Contact
              </button>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-wide text-sm mb-6">
              Contact
            </h4>
            <div className="space-y-4">
              <a 
                href={`mailto:${contactInfo.email}`}
                className="flex items-center gap-3 text-[#94a3b8] hover:text-white transition-colors duration-300 font-medium"
              >
                <Mail size={18} className="text-[#3b82f6]" />
                <span>{contactInfo.email}</span>
              </a>
              <a 
                href={`tel:${contactInfo.phone}`}
                className="flex items-center gap-3 text-[#94a3b8] hover:text-white transition-colors duration-300 font-medium"
              >
                <Phone size={18} className="text-[#3b82f6]" />
                <span>{contactInfo.phone}</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#1e293b] pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#94a3b8] text-sm font-medium">
              © {currentYear} The Real Estate Paralegal. All rights reserved.
            </p>
            <p className="text-[#94a3b8] text-sm font-medium">
              Professional Paralegal Services for Attorneys
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
